import { useHistory } from 'react-router-dom';

export const RedirectPage = () => {
    const history = useHistory();
    // Make sure we're in the browser
    if (typeof window !== 'undefined') {
        history.push('/login');
    }
    return null;
};
